import { FormikErrors } from 'formik';
import { WrapperErrorResponse, ApiDetailResponse, ApiResponse } from '@weddingspot/ws-api-client';

// TODO: move this typedef to API client or replace w/ API client's implementation

// special key for top-level errors
export type BaseWsApiErrorContent = { __errors__?: string[] };

// error type for each individual endpoint
export type WsApiErrorContent<Values> = BaseWsApiErrorContent &
    {
        [K in keyof Values]?: Values[K] extends (string | number)[]
            ? string[]
            : Values[K] extends object
            ? WsApiErrorContent<Values[K]>
            : string[];
    };

// Full parsed API error into formik error style
export type WsFormikError<V> = { __errors__?: string } & FormikErrors<V>;

// Wrapped 400 validation error type
export type WrappedWsApiValidationError<V> = WrapperErrorResponse<ApiResponse<WsApiErrorContent<V>>>;

// Wrapped (e.g. 401, 404, 500)
export type WrappedWsApiMessageError = WrappedWsApiValidationError<ApiResponse<ApiDetailResponse>>;

// Wrapped unexpected error (e.g. axios exceptions)
export type WrappedWsUnexpectedError = WrapperErrorResponse<any>;

// Super type
export type WrappedWsApiError<T> = WrappedWsApiValidationError<T> | WrappedWsApiMessageError | WrappedWsUnexpectedError;

/**
 * Convert a ws-api-client error to
 * a formik error
 */
export const toFormikError = function toFormikError<V>(errors: WrappedWsApiValidationError<V>): WsFormikError<V> {
    // Convert API error to Formik error
    const errContent = errors.detail.content;

    const unpack = function (obj: any) {
        let copy: FormikErrors<V> = {};

        Object.keys(obj).map((k) => {
            const val = obj[k];

            if (Array.isArray(val)) {
                if (typeof val[0] === 'string') {
                    copy[k] = val[0];
                } else if (typeof val[0] === 'object') {
                    copy[k] = val.map((i) => unpack(i));
                }
            } else if (typeof val === 'object') {
                copy[k] = unpack(val);
            } else if (typeof val === 'string') {
                copy[k] = val;
            }
        });

        return copy;
    };

    return unpack(errContent);
};
